/**
 * @fileoverview App Slice
 * @description Global application state slice
 * @module store/slices/appSlice
 */

/**
 * Initial state for the app slice
 */
export const initialAppState = {
  theme: 'light',
  sidebarOpen: true,
  notifications: [],
  isLoading: false,
};

/**
 * App state reducer
 * This is a placeholder - replace with your state management solution
 * (Redux Toolkit, Zustand, etc.)
 * 
 * @param {Object} state - Current state
 * @param {Object} action - Action object
 * @returns {Object} New state
 */
export const appReducer = (state = initialAppState, action) => {
  switch (action.type) {
    case 'SET_THEME':
      return { ...state, theme: action.payload };
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarOpen: !state.sidebarOpen };
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'ADD_NOTIFICATION':
      return { ...state, notifications: [...state.notifications, action.payload] };
    case 'REMOVE_NOTIFICATION':
      return {
        ...state,
        notifications: state.notifications.filter((n) => n.id !== action.payload),
      };
    default:
      return state;
  }
};

/**
 * Action creators
 */
export const appActions = {
  setTheme: (theme) => ({ type: 'SET_THEME', payload: theme }),
  toggleSidebar: () => ({ type: 'TOGGLE_SIDEBAR' }),
  setLoading: (isLoading) => ({ type: 'SET_LOADING', payload: isLoading }),
  addNotification: (notification) => ({ type: 'ADD_NOTIFICATION', payload: notification }),
  removeNotification: (id) => ({ type: 'REMOVE_NOTIFICATION', payload: id }),
};
